// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA53fwlRBG7j6M4llrWY9zu627ujXW0Gjc",
  authDomain: "project-3-246e0.firebaseapp.com",
  projectId: "project-3-246e0",
  storageBucket: "project-3-246e0.firebasestorage.app",
  messagingSenderId: "389996081444",
  appId: "1:389996081444:web:cef5f9b6da5ee5adfc43b1",
  measurementId: "G-6H0TP6C93E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const db = getFirestore(app);
